import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BottomNav } from '../components';
import { DesktopShell } from './DesktopShell';
import { useSurface } from '../hooks/useSurface';
import { BackButton } from '../components/TelegramButtons';

/**
 * Picks the layout for the current surface.
 *
 * Desktop gets the 60px header + 280px sidebar + 720px content column, and its
 * overview route renders sidebar *and* detail pane together rather than a
 * separate page. Telegram and web-mobile share the single-column shell; only
 * web-mobile draws its own header, since Telegram supplies one.
 */
export function AppShell() {
  const { isDesktop } = useSurface();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Back target, ported from the spec: rename / delete / share return to the
  // list detail, everything else returns to the overview.
  const backTarget = resolveBackTarget(pathname);

  if (isDesktop) {
    return (
      <DesktopShell>
        <Outlet />
      </DesktopShell>
    );
  }

  return (
    <div className="app">
      <BackButton onBack={backTarget ? () => navigate(backTarget) : null} />
      <div className="app__scroll">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}

export function resolveBackTarget(pathname: string): string | null {
  if (pathname === '/') return null;
  const detailMatch = pathname.match(/^\/lists\/(\d+)\/(rename|delete|share)$/);
  if (detailMatch) return `/lists/${detailMatch[1]}`;
  return '/';
}
